module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"future-shop","start_url":"/","background_color":"#336999","theme_color":"#336999","display":"minimal-ui","icon":"src/images/boxy.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"5fd07ba440d123c4c596efd4a78b6cf4"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
